import ExploreNavBarLink from './components/ExploreNavBarLink';
import GoldHomeNavBarLink from './components/GoldHomeNavBarLink';
import MatchesNavBarLink from './components/MatchesNavBarLink';
import ProfileNavBarLink from './components/ProfileNavBarLink';
import RecsNavBarLink from './components/RecsNavBarLink';

const NAV_EXPLORE = 'explore';
const NAV_GOLD_HOME = 'goldHome';
const NAV_MATCHES = 'matches';
const NAV_PROFILE = 'profile';
const NAV_RECS = 'recs';

type RouteComponentType = React.ElementType;

type ValidType =
  | typeof NAV_EXPLORE
  | typeof NAV_GOLD_HOME
  | typeof NAV_MATCHES
  | typeof NAV_PROFILE
  | typeof NAV_RECS;

const navMapping: Record<ValidType, RouteComponentType> = {
  [NAV_EXPLORE]: ExploreNavBarLink,
  [NAV_GOLD_HOME]: GoldHomeNavBarLink,
  [NAV_MATCHES]: MatchesNavBarLink,
  [NAV_PROFILE]: ProfileNavBarLink,
  [NAV_RECS]: RecsNavBarLink,
};

export default navMapping;
